// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mediaMinHeight[data-v-edda8b0c]{min-height:5rem}.avatarPosition[data-v-edda8b0c]{bottom:0;left:-.25rem}.placeCard[data-v-edda8b0c]{min-height:200px;height:200px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
